let arrAllProducts = [
    // Start LIPSTICK JSON 
    {
        idx: 0,
        sku_id: "LIPSTICK_0",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 167,
        g: 95,
        b: 80,
        a: 0.8,
        finish_intensity: 0.15,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "sincere",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342231081185",
    },

    {
        idx: 1,
        sku_id: "LIPSTICK_1",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 123,
        g: 69,
        b: 46,
        a: 1,
        finish_intensity: 0.15,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "truth",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342231113953",
    },
    {
        idx: 2,
        sku_id: "LIPSTICK_2",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 214,
        g: 131,
        b: 135,
        a: 1,
        finish_intensity: 1,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "grace",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230884577",
    },
    {
        idx: 3,
        sku_id: "LIPSTICK_3",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 218,
        g: 47,
        b: 67,
        a: 1,
        finish_intensity: 1,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "brave",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230720737",
    },
    {
        idx: 4,
        sku_id: "LIPSTICK_4",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 146,
        g: 86,
        b: 71,
        a: 1,
        finish_intensity: 0.15,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "beauty",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230687969",
    },
    {
        idx: 5,
        sku_id: "LIPSTICK_5",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 208,
        g: 42,
        b: 47,
        a: 1,
        finish_intensity: 1,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "passionate",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342231048417",
    },
    {
        idx: 6,
        sku_id: "LIPSTICK_6",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 230,
        g: 42,
        b: 28,
        a: 1,
        finish_intensity: 1,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "creative",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230753505",
    },
    {
        idx: 7,
        sku_id: "LIPSTICK_7",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 82,
        g: 42,
        b: 57,
        a: 0.9,
        finish_intensity: 1,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "intuitive",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230950113",
    },
    {
        idx: 8,
        sku_id: "LIPSTICK_8",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 87,
        g: 42,
        b: 49,
        a: 1,
        finish_intensity: 0.35,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "inspired",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230917345",
    },
    {
        idx: 9,
        sku_id: "LIPSTICK_9",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 117,
        g: 88,
        b: 60,
        a: 1,
        finish_intensity: 0.35,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "lovely",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230982881",
    },
    {
        idx: 10,
        sku_id: "LIPSTICK_10",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 205,
        g: 141,
        b: 149,
        a: 1,
        finish_intensity: 0.15,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "gentle",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230851809",
    },
    {
        idx: 11,
        sku_id: "LIPSTICK_11",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 83,
        g: 50,
        b: 121,
        a: 1,
        finish_intensity: 0.35,
        finish_type: 0,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "dreamer",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230786273",
    },
    {
        idx: 12,
        sku_id: "LIPSTICK_12",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 229,
        g: 36,
        b: 145,
        a: 0.9,
        finish_intensity: 0.05,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "optimistic",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342231015649",
    },
    {
        idx: 13,
        sku_id: "LIPSTICK_13",
        sku_name: "color-it",
        type: "LIPSTICK",
        r: 228,
        g: 72,
        b: 48,
        a: 1,
        finish_intensity: 0.05,
        finish_type: 2,
        glitter_mask: "lipGlitter_2",
        glitter_intensity: 0,
        shimmer_mask: "lipShimmer_1",
        shimmer_intensity: 0,
        label: "Lipstick",
        name: "fiery",
        product_link: "https://threadbeauty.co/products/color-it",
        is_makeover_product: false,
        makeover_category: "Lips",
        variant_id: "42342230819041",
    },
    // END LIPSTICK JSON

    //   START GLOSS IT JSON
    //    {
    //         idx: 0,
    //         sku_id: "LIPSTICK_0",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 124,
    //         g: 56,
    //         b: 41,
    //         a: 0.7,
    //         finish_intensity: 0.9,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "winner",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42805350826209",
    //     },

    //     {
    //         idx: 1,
    //         sku_id: "LIPSTICK_1",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 98,
    //         g: 59,
    //         b: 42,
    //         a: 0.9,
    //         finish_intensity: 1,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "glossy",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42805350858977",
    //     },
    //     {
    //         idx: 2,
    //         sku_id: "LIPSTICK_2",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 184,
    //         g: 129,
    //         b: 127,
    //         a: 0.7,
    //         finish_intensity: 1,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "influencer",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42805350891745",
    //     },
    //     {
    //         idx: 3,
    //         sku_id: "LIPSTICK_3",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 244,
    //         g: 54,
    //         b: 76,
    //         a: 0.6,
    //         finish_intensity: 1,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "focused",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42805350924513",
    //     },
    //     {
    //         idx: 4,
    //         sku_id: "LIPSTICK_4",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 85,
    //         g: 53,
    //         b: 30,
    //         a: 0.7,
    //         finish_intensity: 1,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "driven",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42805350957281",
    //     },
    //     {
    //         idx: 5,
    //         sku_id: "LIPSTICK_5",
    //         sku_name: "gloss-it",
    //         type: "LIPSTICK",
    //         r: 203,
    //         g: 44,
    //         b: 48,
    //         a: 0.9,
    //         finish_intensity: 1,
    //         finish_type: 0,
    //         glitter_mask: "lipGlitter_2",
    //         glitter_intensity: 0,
    //         shimmer_mask: "lipShimmer_1",
    //         shimmer_intensity: 0,
    //         label: "Lipstick",
    //         name: "takepride",
    //         product_link: "https://threadbeauty.co/products/color-it",
    //         is_makeover_product: false,
    //         makeover_category: "Lips",
    //         variant_id: "42878724341985",
    //     },

    //   END GLOSS IT JSON

    // Start BLUSH JSON
    {
        idx: 14,
        sku_id: "BLUSH_14",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 217,
        g: 128,
        b: 117,
        a: 0.75,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 1,
        shimmer_r: 225,
        shimmer_g: 167,
        shimmer_b: 156,
        mask: "blush_2",
        label: "Blush",
        name: "ambitious",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037667889377",
    },
    {
        idx: 15,
        sku_id: "BLUSH_15",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 194,
        g: 11,
        b: 30,
        a: 0.4,
        min_opacity: 0,
        max_opacity: 0.7,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.75,
        shimmer_r: 247,
        shimmer_g: 159,
        shimmer_b: 134,
        mask: "blush_2",
        label: "Blush",
        name: "peace",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037648523489",
    },
    {
        idx: 16,
        sku_id: "BLUSH_16",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 192,
        g: 121,
        b: 59,
        a: 0.8,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.85,
        shimmer_r: 254,
        shimmer_g: 235,
        shimmer_b: 205,
        mask: "blush_2",
        label: "Blush",
        name: "patient",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037654323425",
    },
    {
        idx: 17,
        sku_id: "BLUSH_17",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 223,
        g: 183,
        b: 237,
        a: 0.8,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 1,
        shimmer_r: 241,
        shimmer_g: 197,
        shimmer_b: 230,
        mask: "blush_2",
        label: "Blush",
        name: "outgoing",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037655339233",
    },
    {
        idx: 18,
        sku_id: "BLUSH_18",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 152,
        g: 42,
        b: 41,
        a: 0.7,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.2,
        shimmer_r: 227,
        shimmer_g: 153,
        shimmer_b: 141,
        mask: "blush_2",
        label: "Blush",
        name: "authentic",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037663891681",
    },
    {
        idx: 19,
        sku_id: "BLUSH_19",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 146,
        g: 58,
        b: 86,
        a: 0.8,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.2,
        shimmer_r: 255,
        shimmer_g: 255,
        shimmer_b: 255,
        mask: "blush_2",
        label: "Blush",
        name: "fearless",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037661663457",
    },
    {
        idx: 20,
        sku_id: "BLUSH_20",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 178,
        g: 62,
        b: 39,
        a: 0.8,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.2,
        shimmer_r: 255,
        shimmer_g: 255,
        shimmer_b: 255,
        mask: "blush_2",
        label: "Blush",
        name: "humble",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037656944865",
    },
    {
        idx: 21,
        sku_id: "BLUSH_21",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 193,
        g: 66,
        b: 38,
        a: 1,
        shimmer_mask: "",
        shimmer_intensity: 0,
        shimmer_r: '',
        shimmer_g: '',
        shimmer_b: '',
        mask: "blush_2",
        label: "Blush",
        name: "giver",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037659926753",
    },
    {
        idx: 22,
        sku_id: "BLUSH_22",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 194,
        g: 91,
        b: 60,
        a: 0.6,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0,
        shimmer_r: 243,
        shimmer_g: 224,
        shimmer_b: 201,
        mask: "blush_2",
        label: "Blush",
        name: "loyal",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037656191201",
    },
    {
        idx: 23,
        sku_id: "BLUSH_23",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 218,
        g: 48,
        b: 53,
        a: 0.4,
        min_opacity: 0,
        max_opacity: 0.65,
        shimmer_mask: "",
        shimmer_intensity: 0,
        shimmer_r: 156,
        shimmer_g: 49,
        shimmer_b: 60,
        mask: "blush_2",
        label: "Blush",
        name: "fighter",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037660713185",
    },
    {
        idx: 24,
        sku_id: "BLUSH_24",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 135,
        g: 87,
        b: 58,
        a: 0.65,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.6,
        shimmer_r: 209,
        shimmer_g: 164,
        shimmer_b: 87,
        mask: "blush_2",
        label: "Blush",
        name: "conqueror",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037662286049",
    },
    {
        idx: 25,
        sku_id: "BLUSH_25",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 249,
        g: 120,
        b: 152,
        a: 0.4,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0.7,
        shimmer_r: 176,
        shimmer_g: 109,
        shimmer_b: 43,
        mask: "blush_2",
        label: "Blush",
        name: "soft",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777440993",
    },
    {
        idx: 26,
        sku_id: "BLUSH_26",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 105,
        g: 44,
        b: 23,
        a: 0.55,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 0,
        shimmer_r: 239,
        shimmer_g: 157,
        shimmer_b: 99,
        mask: "blush_2",
        label: "Blush",
        name: "woke",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777473761",
    },
    {
        idx: 27,
        sku_id: "BLUSH_27",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 123,
        g: 65,
        b: 38,
        a: 0.75,
        shimmer_mask: "blush_shimmer_2",
        shimmer_intensity: 1,
        shimmer_r: 252,
        shimmer_g: 208,
        shimmer_b: 142,
        mask: "blush_2",
        label: "Blush",
        name: "grateful",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037657174241",
    },

    // END Blush JSON

    // Start Highlighter JSON

    {
        idx: 28,
        sku_id: "BLUSH_28",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 217,
        g: 128,
        b: 117,
        a: 0.75,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 1,
        shimmer_r: 225,
        shimmer_g: 167,
        shimmer_b: 156,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "ambitious",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037667889377",
    },
    {
        idx: 29,
        sku_id: "BLUSH_29",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 194,
        g: 11,
        b: 30,
        a: 0.4,
        min_opacity: 0,
        max_opacity: 0.7,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.75,
        shimmer_r: 247,
        shimmer_g: 159,
        shimmer_b: 134,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "peace",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037648523489",
    },
    {
        idx: 30,
        sku_id: "BLUSH_30",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 192,
        g: 121,
        b: 59,
        a: 0.5,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.85,
        shimmer_r: 254,
        shimmer_g: 235,
        shimmer_b: 205,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "patient",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037654323425",
    },
    {
        idx: 31,
        sku_id: "BLUSH_31",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 223,
        g: 183,
        b: 237,
        a: 0.75,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 1,
        shimmer_r: 241,
        shimmer_g: 197,
        shimmer_b: 230,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "outgoing",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037655339233",
    },
    {
        idx: 32,
        sku_id: "BLUSH_32",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 152,
        g: 42,
        b: 41,
        a: 0.7,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.2,
        shimmer_r: 227,
        shimmer_g: 153,
        shimmer_b: 141,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "authentic",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037663891681",
    },
    {
        idx: 33,
        sku_id: "BLUSH_33",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 146,
        g: 58,
        b: 86,
        a: 0.7,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.2,
        shimmer_r: 255,
        shimmer_g: 255,
        shimmer_b: 255,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "fearless",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037661663457",
    },
    {
        idx: 34,
        sku_id: "BLUSH_34",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 178,
        g: 62,
        b: 39,
        a: 0.7,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.2,
        shimmer_r: 255,
        shimmer_g: 255,
        shimmer_b: 255,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "humble",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037656944865",
    },
    {
        idx: 35,
        sku_id: "BLUSH_35",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 193,
        g: 66,
        b: 38,
        a: 0.75,
        shimmer_mask: "",
        shimmer_intensity: 0,
        shimmer_r: '',
        shimmer_g: '',
        shimmer_b: '',
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "giver",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037659926753",
    },
    {
        idx: 36,
        sku_id: "BLUSH_36",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 194,
        g: 91,
        b: 60,
        a: 0.6,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0,
        shimmer_r: 243,
        shimmer_g: 224,
        shimmer_b: 201,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "loyal",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037656191201",
    },
    {
        idx: 37,
        sku_id: "BLUSH_37",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 218,
        g: 48,
        b: 53,
        a: 0.4,
        min_opacity: 0,
        max_opacity: 0.65,
        shimmer_mask: "",
        shimmer_intensity: 0,
        shimmer_r: 156,
        shimmer_g: 49,
        shimmer_b: 60,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "fighter",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037660713185",
    },
    {
        idx: 38,
        sku_id: "BLUSH_38",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 135,
        g: 87,
        b: 58,
        a: 0.65,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.6,
        shimmer_r: 209,
        shimmer_g: 164,
        shimmer_b: 87,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "conqueror",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037662286049",
    },
    {
        idx: 39,
        sku_id: "BLUSH_39",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 249,
        g: 120,
        b: 152,
        a: 0.4,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.7,
        shimmer_r: 176,
        shimmer_g: 109,
        shimmer_b: 43,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "soft",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777440993",
    },
    {
        idx: 40,
        sku_id: "BLUSH_40",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 105,
        g: 44,
        b: 23,
        a: 0.55,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0,
        shimmer_r: 239,
        shimmer_g: 157,
        shimmer_b: 99,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "woke",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777473761",
    },
    {
        idx: 41,
        sku_id: "BLUSH_41",
        sku_name: "blend-it",
        type: "BLUSH",
        r: 123,
        g: 65,
        b: 38,
        a: 0.75,
        shimmer_mask: "blush_shimmer_1",
        shimmer_intensity: 0.85,
        shimmer_r: 252,
        shimmer_g: 208,
        shimmer_b: 142,
        mask: "blush_1",
        label: "Blush as Highlighter",
        name: "grateful",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037657174241",
    },

    //     // End Highlighter JSON

    //     // Start Eyeshadow JSON
    {
        idx: 42,
        sku_id: "EYESHADOW_42",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 217,
        g: 128,
        b: 117,
        a: 1,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.6,
        mask: "eyeshadow_15",
        shimmer_r: 225,
        shimmer_g: 167,
        shimmer_b: 156,
        label: "Eyeshadow",
        name: "ambitious",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037667889377",
    },
    {
        idx: 43,
        sku_id: "EYESHADOW_43",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 192,
        g: 121,
        b: 59,
        a: 0.75,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.4,
        mask: "eyeshadow_15",
        shimmer_r: 254,
        shimmer_g: 235,
        shimmer_b: 205,
        label: "Eyeshadow",
        name: "patient",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037654323425",
    },
    {
        idx: 44,
        sku_id: "EYESHADOW_44",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 223,
        g: 183,
        b: 237,
        a: 0.85,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.6,
        mask: "eyeshadow_15",
        shimmer_r: 241,
        shimmer_g: 197,
        shimmer_b: 230,
        label: "Eyeshadow",
        name: "outgoing",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037655339233",
    },
    {
        idx: 45,
        sku_id: "EYESHADOW_45",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 152,
        g: 42,
        b: 41,
        a: 1,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.4,
        mask: "eyeshadow_15",
        shimmer_r: 227,
        shimmer_g: 153,
        shimmer_b: 141,
        label: "Eyeshadow",
        name: "authentic",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037663891681",
    },
    {
        idx: 46,
        sku_id: "EYESHADOW_46",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 194,
        g: 91,
        b: 60,
        a: 1,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.4,
        mask: "eyeshadow_15",
        shimmer_r: 243,
        shimmer_g: 224,
        shimmer_b: 201,
        label: "Eyeshadow",
        name: "loyal",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037656191201",
    },
    {
        idx: 47,
        sku_id: "EYESHADOW_47",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 135,
        g: 87,
        b: 58,
        a: 0.7,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.6,
        mask: "eyeshadow_15",
        shimmer_r: 209,
        shimmer_g: 164,
        shimmer_b: 87,
        label: "Eyeshadow",
        name: "conqueror",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037662286049",
    },
    {
        idx: 48,
        sku_id: "EYESHADOW_48",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 249,
        g: 120,
        b: 152,
        a: 0.4,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.7,
        mask: "eyeshadow_15",
        shimmer_r: 176,
        shimmer_g: 109,
        shimmer_b: 43,
        label: "Eyeshadow",
        name: "soft",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777440993",
    },
    {
        idx: 49,
        sku_id: "EYESHADOW_49",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 105,
        g: 44,
        b: 23,
        a: 0.8,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.6,
        mask: "eyeshadow_15",
        shimmer_r: 239,
        shimmer_g: 157,
        shimmer_b: 99,
        label: "Eyeshadow",
        name: "woke",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42341777473761",
    },
    {
        idx: 50,
        sku_id: "EYESHADOW_50",
        sku_name: "blend-it",
        type: "EYESHADOW",
        r: 123,
        g: 65,
        b: 38,
        a: 0.8,
        shimmer_mask: "eyeshadow_shimmer_15",
        shimmer_intensity: 0.5,
        mask: "eyeshadow_15",
        shimmer_r: 252,
        shimmer_g: 208,
        shimmer_b: 142,
        label: "Eyeshadow",
        name: "grateful",
        product_link: "https://threadbeauty.co/products/blend-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42037657174241",
    },

    // End Eyeshadow JSON

    // Start Foundation - Full Face JSON
  {
        idx: 049,
        sku_id: "FOUNDATION_049",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 230,
        g: 208,
        b: 176,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "00 fair",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745407713",
    },
  {
        idx: 050,
        sku_id: "FOUNDATION_050",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 221,
        g: 192,
        b: 160,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "00 fair light",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745440481",
    },
    {
        idx: 51,
        sku_id: "FOUNDATION_51",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 235,
        g: 192,
        b: 154,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "10 light cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322012385",
    },
    {
        idx: 52,
        sku_id: "FOUNDATION_52",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 227,
        g: 183,
        b: 141,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "20 light olive",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322045153",
    },
    {
        idx: 53,
        sku_id: "FOUNDATION_53",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 219,
        g: 175,
        b: 140,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "30 light golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322077921",
    },
    {
        idx: 54,
        sku_id: "FOUNDATION_54",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 224,
        g: 157,
        b: 120,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "40 light neutral warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322110689",
    },
    {
        idx: 55,
        sku_id: "FOUNDATION_55",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 212,
        g: 168,
        b: 131,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "50 light tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322143457",
    },
    {
        idx: 56,
        sku_id: "FOUNDATION_56",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 197,
        g: 148,
        b: 114,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "60 tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322176225",
    },
    {
        idx: 57,
        sku_id: "FOUNDATION_57",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 211,
        g: 150,
        b: 107,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "70 tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322208993",
    },
    {
        idx: 58,
        sku_id: "FOUNDATION_58",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 211,
        g: 134,
        b: 107,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "80 tan warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322241761",
    },
    {
        idx: 59,
        sku_id: "FOUNDATION_59",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 178,
        g: 107,
        b: 75,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "90 deep tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322274529",
    },
    {
        idx: 60,
        sku_id: "FOUNDATION_60",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 186,
        g: 115,
        b: 62,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "100 deep tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322307297",
    },
    {
        idx: 61,
        sku_id: "FOUNDATION_61",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 175,
        g: 116,
        b: 82,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "110 medium golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322340065",
    },
    {
        idx: 62,
        sku_id: "FOUNDATION_62",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 176,
        g: 111,
        b: 87,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "120 medium warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322372833",
    },
    {
        idx: 63,
        sku_id: "FOUNDATION_63",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 170,
        g: 103,
        b: 86,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "130 medium warm golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322405601",
    },
    {
        idx: 64,
        sku_id: "FOUNDATION_64",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 170,
        g: 99,
        b: 60,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "140 medium neutral brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322438369",
    },
    {
        idx: 65,
        sku_id: "FOUNDATION_65",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 163,
        g: 94,
        b: 67,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "150 medium deep cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322471137",
    },
    {
        idx: 66,
        sku_id: "FOUNDATION_66",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 131,
        g: 70,
        b: 39,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "160 rich brown warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322503905",
    },
    {
        idx: 67,
        sku_id: "FOUNDATION_67",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 116,
        g: 60,
        b: 40,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.8,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "170 rich brown red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322536673",
    },
    {
        idx: 68,
        sku_id: "FOUNDATION_68",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 97,
        g: 50,
        b: 31,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "180 rich brown cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322569441",
    },
    {
        idx: 69,
        sku_id: "FOUNDATION_69",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 83,
        g: 40,
        b: 23,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.8,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "190 rich brown neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322602209",
    },
    {
        idx: 70,
        sku_id: "FOUNDATION_70",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 94,
        g: 48,
        b: 27,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "200 deep cool brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322634977",
    },
    {
        idx: 71,
        sku_id: "FOUNDATION_71",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 88,
        g: 32,
        b: 12,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "210 deep red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322667745",
    },
    {
        idx: 72,
        sku_id: "FOUNDATION_72",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 87,
        g: 42,
        b: 25,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.8,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "220 deep neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322700513",
    },
    {
        idx: 73,
        sku_id: "FOUNDATION_73",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 84,
        g: 41,
        b: 26,
        a: 0.7,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "230 deepest warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322733281",
    },
    {
        idx: 74,
        sku_id: "FOUNDATION_74",
        sku_name: "face-it",
        type: "FOUNDATION",
        r: 64,
        g: 28,
        b: 13,
        a: 0.8,
        min_opacity: 0.25,
        max_opacity: 0.75,
        finish_intensity: 0.20,
        finish_type: "Dewy_3",
        mask: "foundation_fullface",
        smoothing_coefficent: 0.5,
        shininess: 0,
        mask_intensity: 0.4,
        blending_ratio: 0.05,
        label: "Foundation",
        name: "240 deepest cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322766049",
    },

    //     // End Foundation - Full Face JSON

    //     // Start Foundation - Contour JSON
     {
        idx: 073,
        sku_id: "CONTOUR_073",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 230,
        g: 208,
        b: 176,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "00 fair",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745407713",
    },
     {
        idx: 074,
        sku_id: "CONTOUR_074",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 221,
        g: 192,
        b: 160,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "05 fair light",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745440481",
    },
  {
        idx: 75,
        sku_id: "CONTOUR_75",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 235,
        g: 192,
        b: 154,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "10 light cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322012385",
    },
    {
        idx: 76,
        sku_id: "CONTOUR_76",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 227,
        g: 183,
        b: 141,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "20 light olive",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322045153",
    },
    {
        idx: 77,
        sku_id: "CONTOUR_77",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 219,
        g: 175,
        b: 140,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "30 light golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322077921",
    },
    {
        idx: 78,
        sku_id: "CONTOUR_78",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 224,
        g: 157,
        b: 120,
        a: 0.6,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "40 light neutral warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322110689",
    },
    {
        idx: 79,
        sku_id: "CONTOUR_79",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 212,
        g: 168,
        b: 131,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "50 light tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322143457",
    },
    {
        idx: 80,
        sku_id: "CONTOUR_80",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 197,
        g: 148,
        b: 114,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "60 tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322176225",
    },
    {
        idx: 81,
        sku_id: "CONTOUR_81",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 211,
        g: 150,
        b: 107,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "70 tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322208993",
    },
    {
        idx: 82,
        sku_id: "CONTOUR_82",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 211,
        g: 134,
        b: 107,
        a: 0.8,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "80 tan warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322241761",
    },
    {
        idx: 83,
        sku_id: "CONTOUR_83",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 178,
        g: 107,
        b: 75,
        a: 0.8,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "90 deep tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322274529",
    },
    {
        idx: 84,
        sku_id: "CONTOUR_84",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 186,
        g: 115,
        b: 62,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "100 deep tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322307297",
    },
    {
        idx: 85,
        sku_id: "CONTOUR_85",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 175,
        g: 116,
        b: 82,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "110 medium golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322340065",
    },
    {
        idx: 86,
        sku_id: "CONTOUR_86",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 176,
        g: 111,
        b: 87,
        a: 0.8,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "120 medium warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322372833",
    },
    {
        idx: 87,
        sku_id: "CONTOUR_87",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 170,
        g: 103,
        b: 86,
        a: 0.6,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "130 medium warm golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322405601",
    },
    {
        idx: 88,
        sku_id: "CONTOUR_88",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 170,
        g: 99,
        b: 60,
        a: 0.8,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "140 medium neutral brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322438369",
    },
    {
        idx: 89,
        sku_id: "CONTOUR_89",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 163,
        g: 94,
        b: 67,
        a: 0.6,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "150 medium deep cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322471137",
    },
    {
        idx: 90,
        sku_id: "CONTOUR_90",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 131,
        g: 70,
        b: 39,
        a: 0.6,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "160 rich brown warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322503905",
    },
    {
        idx: 91,
        sku_id: "CONTOUR_91",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 116,
        g: 60,
        b: 40,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "170 rich brown red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322536673",
    },
    {
        idx: 92,
        sku_id: "CONTOUR_92",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 97,
        g: 50,
        b: 31,
        a: 0.5,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "180 rich brown cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322569441",
    },
    {
        idx: 93,
        sku_id: "CONTOUR_93",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 83,
        g: 40,
        b: 23,
        a: 0.6,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "190 rich brown neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322602209",
    },
    {
        idx: 94,
        sku_id: "CONTOUR_94",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 94,
        g: 48,
        b: 27,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "200 deep cool brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322634977",
    },
    {
        idx: 95,
        sku_id: "CONTOUR_95",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 88,
        g: 32,
        b: 12,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "210 deep red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322667745",
    },
    {
        idx: 96,
        sku_id: "CONTOUR_96",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 87,
        g: 42,
        b: 25,
        a: 0.5,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "220 deep neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322700513",
    },
    {
        idx: 97,
        sku_id: "CONTOUR_97",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 84,
        g: 41,
        b: 26,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "230 deepest warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322733281",
    },
    {
        idx: 98,
        sku_id: "CONTOUR_98",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 64,
        g: 28,
        b: 13,
        a: 0.7,
        mask: "bronzer_fullface_contour_1",
        label: "Foundation",
        name: "240 deepest cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322766049",
    },

    // End Foundation - Contour JSON

    // Start Foundation - conceal JSON
   {
        idx: 097,
        sku_id: "CONTOUR_097",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 230,
        g: 208,
        b: 176,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "00 fair",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745407713",
    },
     {
        idx: 098,
        sku_id: "CONTOUR_098",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 221,
        g: 192,
        b: 160,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "05 fair light",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "43750745440481",
    },
    {
        idx: 99,
        sku_id: "CONTOUR_99",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 235,
        g: 192,
        b: 154,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "10 light cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322012385",
    },
    {
        idx: 100,
        sku_id: "CONTOUR_100",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 227,
        g: 183,
        b: 141,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "20 light olive",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322045153",
    },
    {
        idx: 101,
        sku_id: "CONTOUR_101",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 219,
        g: 175,
        b: 140,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "30 light golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322077921",
    },
    {
        idx: 102,
        sku_id: "CONTOUR_102",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 224,
        g: 157,
        b: 120,
        a: 0.8,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "40 light neutral warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322110689",
    },
    {
        idx: 103,
        sku_id: "CONTOUR_103",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 212,
        g: 168,
        b: 131,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "50 light tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322143457",
    },
    {
        idx: 104,
        sku_id: "CONTOUR_104",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 197,
        g: 148,
        b: 114,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "60 tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322176225",
    },
    {
        idx: 105,
        sku_id: "CONTOUR_105",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 211,
        g: 150,
        b: 107,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "70 tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322208993",
    },
    {
        idx: 106,
        sku_id: "CONTOUR_106",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 211,
        g: 134,
        b: 107,
        a: 0.5,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "80 tan warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322241761",
    },
    {
        idx: 107,
        sku_id: "CONTOUR_107",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 178,
        g: 107,
        b: 75,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "90 deep tan neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322274529",
    },
    {
        idx: 108,
        sku_id: "CONTOUR_108",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 186,
        g: 115,
        b: 62,
        a: 0.8,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "100 deep tan cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322307297",
    },
    {
        idx: 109,
        sku_id: "CONTOUR_109",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 175,
        g: 116,
        b: 82,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "110 medium golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322340065",
    },
    {
        idx: 110,
        sku_id: "CONTOUR_110",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 176,
        g: 111,
        b: 87,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "120 medium warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322372833",
    },
    {
        idx: 111,
        sku_id: "CONTOUR_111",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 170,
        g: 103,
        b: 86,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "130 medium warm golden",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322405601",
    },
    {
        idx: 112,
        sku_id: "CONTOUR_112",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 170,
        g: 99,
        b: 60,
        a: 0.8,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "140 medium neutral brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322438369",
    },
    {
        idx: 113,
        sku_id: "CONTOUR_113",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 163,
        g: 94,
        b: 67,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "150 medium deep cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322471137",
    },
    {
        idx: 114,
        sku_id: "CONTOUR_114",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 131,
        g: 70,
        b: 39,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "160 rich brown warm",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322503905",
    },
    {
        idx: 115,
        sku_id: "CONTOUR_115",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 116,
        g: 60,
        b: 40,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "170 rich brown red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322536673",
    },
    {
        idx: 116,
        sku_id: "CONTOUR_116",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 97,
        g: 50,
        b: 31,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "180 rich brown cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322569441",
    },
    {
        idx: 117,
        sku_id: "CONTOUR_117",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 83,
        g: 40,
        b: 23,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "190 rich brown neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322602209",
    },
    {
        idx: 118,
        sku_id: "CONTOUR_118",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 94,
        g: 48,
        b: 27,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "200 deep cool brown",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322634977",
    },
    {
        idx: 119,
        sku_id: "CONTOUR_119",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 88,
        g: 32,
        b: 12,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "210 deep red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322667745",
    },
    {
        idx: 120,
        sku_id: "CONTOUR_120",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 87,
        g: 42,
        b: 25,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "220 deep neutral",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322700513",
    },
    {
        idx: 121,
        sku_id: "CONTOUR_121",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 84,
        g: 41,
        b: 26,
        a: 0.7,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "230 deepest warm red",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322733281",
    },
    {
        idx: 122,
        sku_id: "CONTOUR_122",
        sku_name: "face-it",
        type: "CONTOUR",
        r: 64,
        g: 28,
        b: 13,
        a: 0.6,
        mask: "bronzer_fullface_contour_2",
        label: "Foundation",
        name: "240 deepest cool",
        product_link: "https://threadbeauty.co/products/face-it",
        is_makeover_product: false,
        makeover_category: "Face",
        variant_id: "42342322766049",
    },

    // End Foundation - Highlighter JSON
];
